import { Link } from 'react-router-dom'
import Icon from './Icon'

export function ArticleCard({ article }) {
  return <article className="content-card"><span className="tag">{article.category}</span><h3><Link to={`/articles/${article.slug}`}>{article.title}</Link></h3><p>{article.description}</p><div className="card-meta"><span>{article.updated}</span><Link to={`/articles/${article.slug}`}>阅读全文 <Icon name="arrow" size={17} /></Link></div></article>
}

export function CaseCard({ item }) {
  return <article className="content-card case-card"><div className="case-tags">{item.tags.map((tag) => <span key={tag}>{tag}</span>)}</div><h3><Link to={`/cases/${item.slug}`}>{item.title}</Link></h3><p>{item.description}</p><Link className="text-link" to={`/cases/${item.slug}`}>查看案例 <Icon name="arrow" size={17} /></Link></article>
}

export function ContactCTA({ title = '需要选型或技术支持？' }) {
  return <section className="contact-cta"><div><p className="section-kicker light">技术支持</p><h2>{title}</h2><p>准备好制冷剂、温度、制冷量、管径等工况信息，我们将更快地协助您判断。</p></div><div><a className="button white" href="tel:+8615372829178"><Icon name="phone" />15372829178</a><a className="button ghost" href="mailto:phonetoo@126.com"><Icon name="mail" />发送邮件</a></div></section>
}
